export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
